import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Ensures every route change resets the page scroll to the top-left.
 * React Router preserves scroll by default, which is jarring when jumping
 * between long product pages.
 */
const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Use 'auto' (not 'smooth') so admins don't watch it slide on every click.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search]);
  return null;
};

export default ScrollToTop;
